export enum ProfileTypeEnum {
  ActiveDuty = '1',
  Veteran = '2',
  Spouse = '3'
}
